import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgArchived = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M4.202 14h7.596q1.074 0 1.643-.564.567-.557.568-1.63V5.31H1.99v6.497q0 1.08.568 1.636.57.557 1.643.557m1.566-6.037a.55.55 0 0 1-.409-.16.58.58 0 0 1-.152-.418V7.17q0-.257.152-.41a.55.55 0 0 1 .41-.16h4.47q.249 0 .409.16.159.152.159.41v.216a.57.57 0 0 1-.16.418.55.55 0 0 1-.408.16zm-3.507-3.67h11.484q.624 0 .936-.348.32-.348.319-.967v-.662q0-.62-.319-.968Q14.37 1 13.746 1H2.26q-.596 0-.928.348T1 2.316v.662q0 .62.312.967.318.348.95.349"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgArchived);
export default ForwardRef;
